export const getAllPaymentMethod = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Card", value: "Card" },
    { title: "UPI", value: "UPI " },
    { title: "Cheque", value: "Cheque" },
    { title: "RTGS", value: "RTGS" },
  ];
};
export const getAllPaymentMethodForNoInovice = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Metal", value: "Metal" },
    { title: "Metal to Cash", value: "Metal to Cash" },
    { title: "Cash to Metal", value: "Cash to Metal" },
  ];
};
export const advanceAmountMethods = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Card", value: "Card" },
    { title: "UPI", value: "UPI " },
    { title: "Cheque", value: "Cheque" },
    { title: "RTGS", value: "RTGS" },
  ];
};

export const metals = () => {
  return [
    // {title:"GOLD",value:"Gold"},
    // {title:"SILVER",value:"Silver"},
    // {title:"PLATINUM",value:"Platinum"},
    { title: "PURE GOLD", value: "Pure Gold" },
    { title: "PURE SILVER", value: "Pure Silver" },
    { title: "OLD GOLD", value: "Old Gold" },
    { title: "OLD SILVER", value: "Old Silver" },
  ];
};

export const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Add leading zero
  const day = String(today.getDate()).padStart(2, "0"); // Add leading zero
  return `${year}/${month}/${day}`;
};

export const DiamondFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  // 'DiamondName',
  "DiamondShape",
  "DiamondColour",
  "DiamondClarity",
  "DiamondSleve",
  "DiamondSize",
  "DiamondWeight",
  "DiamondPieces",
  "DiamondRate",
  "DiamondAmount",
  "DiamondCut",
  "DiamondSettingType",
  "DiamondCertificate",
  "DiamondPacket",
  "DiamondBox",
  "DiamondDescription",
];
export const StoneFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  "StoneName",
  "StoneShape",
  "StoneColour",
  "StoneSize",
  "StoneWeight",
  "StoneRateCt",
  "StonePieces",
  "StoneRatePc",
  "StoneAmount",
  "StoneSettingType",
  "StoneCertificate",
  "StonePacket",
  "Box",
  "StoneDescription",
];
export const GeneralFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  "ProductId",
  "DesignId",
  "PurityId",
  "TotalWt",
  "PackingWeight",
  "GrossWt",
  "StoneWt",
  "DiamondWeight",
  "NetWt",
  "Qty",
  "MetalRate",
  "FinePercent",
  "WastagePercent",
  "MakingPerGram",
  "MakingFixedWastage",
  "MakingFixedAmt",
  "StonePieces",
  "StoneAmount",
  "Hallmark",
  "ClipQty",
  "ClipWt",
  "TagWt",
  "FindingWt",
  "LanyardWt",
  "MetalAmount",
  "TotalMakingAmount",
  "TotalItemAmount",
  "FineWt",
  "WastageWt",
  "FineWastageWt",
  "Testing",
  "images",
  "Stone",
  "Diamond",
];

export function generateDropDownList(
  field,
  dropdownListData,
  CategoryId,
  ProductId,
  DesignId,
  PurityId,
  skus,
  VendorName={}
) {
  const list =
    field.key === "StockKeepingUnit"
      ? Array.isArray(dropdownListData?.allSku)
        ? dropdownListData?.allSku?.filter((item)=>item?.Id == VendorName?.value)
        : []
      : field.key === "CategoryId"
      ? Array.isArray(dropdownListData?.categories)
        ? skus?.length
          ? dropdownListData?.categories?.filter(
              (item) => item?.Id == skus[0]?.CategoryId?.value || item?.Id == skus[0]?.CategoryId
            )
          : dropdownListData?.categories
        : []
      : field.key === "ProductId"
      ? Array.isArray(dropdownListData?.productTypes)
        ? dropdownListData.productTypes?.filter(
            (item) => item?.CategoryId == CategoryId?.value
          )
        : []
      : field.key === "DesignId"
      ? Array.isArray(dropdownListData?.designs)
        ? dropdownListData.designs?.filter(
            (item) =>
              item?.CategoryId == CategoryId?.value &&
              item?.ProductId == ProductId?.value
          )
        : []
      : field.key === "PurityId"
      ? Array.isArray(dropdownListData?.purities)
        ? dropdownListData.purities?.filter(
            (item) => item?.CategoryId == CategoryId?.value
          )
        : []
      : field.key === "DiamondShape"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondShape"
          )
        : []
      : field.key === "DiamondClarity"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondClarity"
          )
        : []
      : field.key === "DiamondColour"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondColour"
          )
        : []
      : field.key === "DiamondCut"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondCut"
          )
        : []
      : field.key === "DiamondSettingType"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondSettingType"
          )
        : []
      : [];

  const result = list?.map((item) => {
    if (field.key === "StockKeepingUnit") {
      return { value: item?.Id, label: item?.StockKeepingUnit };
    }
    if (field.key === "CategoryId") {
      return { value: item?.Id, label: item?.CategoryName };
    }
    if (field.key === "ProductId") {
      return { value: item?.Id, label: item?.ProductName };
    }
    if (field.key === "DesignId") {
      return { value: item?.Id, label: item?.DesignName };
    }
    if (field.key === "PurityId") {
      return { value: item?.Id, label: item?.PurityName };
    }
    if (
      field.key === "DiamondShape" ||
      field.key === "DiamondColour" ||
      field.key === "DiamondClarity" ||
      field.key === "DiamondCut" ||
      field.key === "DiamondSettingType"
    ) {
      return { value: item?.Id, label: item?.DiamondValue };
    }
  });
  console.log( [{value:"",label:"--select--"},...result])
  return [{value:"",label:"--select--"},...result];
}

export const HeadersForAllCategory = [
  "Item Details",
  "Total Wt",
  "Gross Wt",
  "Stone Wt",
  "Net Wt",
  "Fine %",
  "Wastage %",
  "F+W Wt",
  "Rate/Gm",
  "Stone Amt",
  "Qty",
  "HallMark Amt",
  "Total Item Amt",
  "Packing Wt",
  "Diamond Wt",
];

export const HeadersForStones = [
  "Item Details",
  "Stone Name	",
  "Shape",
  "Color",
  "Size",
  "Weight",
  "Rate/karate",
  "Pieces",
  "Rate/Piece",
  "Amount",
  "Setting Type",
  "Certificate",
  "Description",
];

export function getPurchaseEntryFormData({
  data,
  selectedFiles,
  vendorlist,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
}) {
  const formData = new FormData();
  const dateToSend = invoiceDate || getTodaysDateFormat()
  let totalWtReceive = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.FineWt) || 0) + (parseFloat(item2?.FineWt) || 0),
    0
  );
  let totalHallmarkAmt = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.Hallmark) || 0) + parseFloat(item2?.Hallmark || 0),
    0
  );
  let totalTagWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.TagWt) || 0) + parseFloat(item2?.TagWt || 0),
    0
  );
  let totalFindingWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.FindingWt) || 0) + parseFloat(item2?.FindingWt || 0),
    0
  );
  let totalLanyardWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.LanyardWt) || 0) + parseFloat(item2?.LanyardWt || 0),
    0
  );

  let unlabelledSilverWeight = data?.skus
    ?.filter(
      (x) =>
        !x.unlabeled && x?.CategoryId?.label.toLowerCase().includes("silver")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let unlabelledGoldWeight = data?.skus
    .filter(
      (x) =>
        !x.unlabeled && x?.CategoryId?.label?.toLowerCase().includes("gold")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let unlabelledOtherMetalWeight = data?.skus
    ?.filter(
      (x) =>
        !x.unlabeled &&
        !x.CategoryId?.label?.toLowerCase().includes("silver") &&
        !x.CategoryId?.label?.toLowerCase().includes("gold")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let totalStoneWeight = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StoneWeight || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalStoneAmount = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StoneAmount || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalStonePieces = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StonePieces || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondWeight = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.DiamondWeight || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondPieces = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone?.DiamondPieces || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondAmount = data?.skus.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.DiamondAmount || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  formData.append(
    "TotalNetAmount",
    parseFloat(data?.TotalTaxableAmount || 0).toFixed(3)
  );
  formData.append("TotalGSTAmount", parseFloat(data?.TotalGst || 0).toFixed(3));
  formData.append(
    "TotalPurchaseAmount",
    parseFloat(data?.TotalBillAmount || 0).toFixed(3)
  );
  formData.append(
    "PurchaseStatus",
    data?.paymentTypes?.length > 0 ? "Partial" : "None"
  );
  formData.append("Quantity", data?.Quantity || 0);
  formData.append(
    "PurchaseAmount",
    parseFloat(data?.TotalBillAmount || 0).toFixed(3)
  );
  formData.append("VendorId", data?.VendorName?.value || "");
  formData.append("GSTApplied", data?.gstCheckbox); //  what is gst applied
  formData.append("Branch", "Home"); //
  formData.append("PurchaseType", "Purchase"); //
  formData.append(
    "Discount",
    parseFloat(data?.TotalRODiscount || 0).toFixed(3)
  ); //
  formData.append("Remark", "");
  formData.append(
    "BalanceGold",
    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
  ); // we have  metal balance
  formData.append(
    "BalanceSilver",
    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append(
    "BalanceAmount",
    parseFloat(data?.TotalBalanceAmount || 0).toFixed(3)
  );
  formData.append("BalanceOtherMetal", "0");
  formData.append("DebitAmount", "0");
  formData.append("DebitGold", "0");
  formData.append("DebitSilver", "0");
  formData.append("DebitOtherMetal", "0");
  formData.append(
    "TotalFineGold",
    parseFloat(data?.TotalFineMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append(
    "TotalFineSilver",
    parseFloat(data?.TotalFineMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append("TotalFineOtherMetal", "0");
  formData.append("InvoiceNo", data?.invoiceNumber || "");
  if (false) {
    // selectedFiles.length > 0
    selectedFiles.forEach((file) => {
      formData.append("InvoiceFile", file);
    });
  } else {
    formData.append("InvoiceFile", "");
  }
  const vndr = vendorlist?.find((item) => item?.Id == data?.VendorName?.value);

  formData.append("InwardNo", `${parseInt(vndr?.InwardNo) + 1}`);
  formData.append("PurchaseDate", dateToSend);
  formData.append("ClientCode", clientCode);
  formData.append("CompanyId", CompanyId || 0);
  formData.append("CounterId", CounterId || 0);
  formData.append("BranchId", BranchId || 0);
  formData.append("EmployeeId", EmployeeId || 0);
  formData.append("TotalWtReceive", totalWtReceive);
  formData.append("TotalFineWithWstageWt", data?.TotalFineMetal);
  const skuid =
    data?.skus?.length && data?.skus[0]?.StockKeepingUnit
      ? data?.skus[0]?.StockKeepingUnit?.value
      : "";
  formData.append("StockKeepingUnit", skuid);
  formData.append("LotNumber", data?.LotNumber || "0");
  formData.append("TotalHallmarkAmount", totalHallmarkAmt);
  formData.append("TotalTagWeight", totalTagWeight);
  formData.append("TotalFindingWeight", totalFindingWeight);
  formData.append("TotalLanyardWeight", totalLanyardWeight);
  formData.append("UnlabelledSilverWeight", unlabelledSilverWeight);
  formData.append("UnlabelledGoldWeight", unlabelledGoldWeight);
  formData.append("UnlabelledOtherMetalWeight", unlabelledOtherMetalWeight);
  formData.append("TotalStoneWeight", totalStoneWeight);
  formData.append("TotalStoneAmount", totalStoneAmount);
  formData.append("TotalStonePieces", totalStonePieces);
  formData.append("TotalDiamondWeight", totalDiamondWeight);
  formData.append("TotalDiamondPieces", totalDiamondPieces);
  formData.append("TotalDiamondAmount", totalDiamondAmount);
  formData.append("AssignedGoldWeight", "0");
  formData.append("AssignedSilverWeight", "0");
  formData.append("AssignedOtherMetalWeight", "0");
  formData.append("AssignedDiamondWeight", "0");

  return formData;
}

export function purchaseEntryJson({ rcvdId, data, additionalInfo ,vendorlist}) {
  const currentYear = new Date().getFullYear();
  const jsonData = data?.skus?.map((product) => {
    // return {
    //   ...item,
    //   LotNumber: "",
    //   MakingPercentage: `${product.MakingPercentage || 0}`,  // we dont have making percentage,
    //   Quantity: item?.Qty,
    //   PurityId: item?.PurityId?.value,
    //   CategoryId: item?.CategoryId?.value,
    //   ProductId: item?.ProductId?.value,
    //   DesignId: item?.DesignId?.value,
    //   FineGoldWt: "",
    //   FineSilverWt: "",
    //   FineOtherMetalWt: "",
    //   TotalStoneAmt: item?.StoneAmount,
    //   TotalItemAmt: item?.TotalItemAmount,
    //   RDPurchaseId: rcvdId,
    //   CategoryName: item?.CategoryId?.label,
    //   ProductName: item?.ProductId?.label,
    //   DesignName: item?.DesignId?.label,
    //   PurityName: item?.PurityId?.label,
    //   Status: "",
    //   CounterId:additionalInfo?.CounterId,
    //   BranchId:additionalInfo?.BranchId,
    //   CompanyId:additionalInfo?.CompanyId,
    //   FinePure: "",
    //   ClientCode: additionalInfo?.clientCode,
    //   StockKeepingUnit: item?.StockKeepingUnit?.value,
    //   ItemCode: "",
    //   AddToUnlabelled: item?.unlabeled,
    //   DiamondName: "",
    //   MetalId: "",
    //   StoneRate: "", // we have stone rate in StoneRateCt and StoneRatePc
    //   HallmarkAmt: item?.Hallmark,
    //   TagWeight: item?.TagWt,
    //   FindingWeight: item?.FindingWt,
    //   LanyardWeight: item?.LanyardWt,
    //   MRP: "",
    //   VendorId: data?.VendorName?.value,
    //   VendorName: data?.VendorName?.label,
    //   FirmName: "",
    //   SKUId: "",
    //   EmployeeId: additionalInfo?.employeeCode,
    //   ConvertAmount: "",
    //   UnlabelledSilverWeight: "",
    //   UnlabelledGoldWeight: "",
    //   UnlabelledOtherMetalWeight: "",
    //   AssignedGoldWeight: "",
    //   AssignedSilverWeight: "",
    //   AssignedOtherMetalWeight: "",
    //   AssignedDiamondWeight: "",
    //   TaxId: "",
    //   TaxPercentage: "",
    //   AvailableGrossWeight: "",
    //   AvailableNetWeight: "",
    //   AvailableStoneWeight: "",
    //   ClipWeight: item?.ClipWt,
    //   ClipQuantity: item?.ClipQty,
    //   DiamondPurchaseRate: "",
    //   DiamondSellRate: "",
    //   DiamondPurchaseAmount: "",
    //   DiamondSellAmount: "",
    //   MetalName: "",
    //   TotalDiamondQty: 0,
    //   TotalDiamondWeight: 0,
    //   TotalDiamondAmount: 0,
    //   TotalDiamondRate: 0,
    //   Stones: item?.Stones?.map((stone) => {
    //     return {
    //       ...stone,
    //       StoneRate: "",
    //       ClientCode: additionalInfo?.clientCode,
    //       RDPurchaseItemId: "",
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    //   Diamonds: item?.Diamonds?.map((diamond) => {
    //     return {
    //       ...diamond,
    //       Certificate: diamond?.DiamondCertificate,
    //       SettingType: diamond?.SettingType,
    //       DiamondPurchaseAmt: "",
    //       Description: diamond?.DiamondDescription,
    //       ClientCode:additionalInfo?.clientCode,
    //       PurchaseItemId: 0,
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    //   Payments: data?.paymentTypes?.map((payment) => {
    //     return {
    //       ...payment,
    //       CustomerId: 0,
    //       PaymentModeType: payment?.mode,
    //       PaymentSource: "",
    //       CreditDebit: "",
    //       Amount: payment?.amount,
    //       TransactionType: "",
    //       InvoiceNumber: data?.invoiceNumber,
    //       PaymentVisibility: "",
    //       FinancialYear: "2024",
    //       Branch: "Home",
    //       FineGold: "",
    //       FineSilver: "",
    //       FineOtherMetal: "",
    //       GoldRate: "0",
    //       SilverRate: "0",
    //       OtherMetalRate: "",
    //       GoldAmount: "",
    //       SilverAmount: "",
    //       OtherMetalAmount: "",
    //       OldGoldGrosswt: "",
    //       OldSilverGrosswt: "",
    //       OtherMetalGrossWt: "",
    //       GoldPurity: "",
    //       SilverPurity: "",
    //       OtherMetalPurity: "",
    //       VendorId: data?.VendorName?.value,
    //       InvoiceId: 0,
    //       InwardNo: "25",
    //       OrderId: 0,
    //       CustomerName: "",
    //       VendorName: data?.VendorName?.label,
    //       RDPurchaseId: 1067,
    //       Status: "Purchased",
    //       Description: payment?.description,
    //       ClientCode:additionalInfo?.clientCode,
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    // };

    const stoneDetails = product.Stones.map((stone) => ({
      StoneName: `${stone.StoneName || ""}`,
      StoneWeight: `${stone.StoneWeight}`,
      // StoneRate: `${stone.StoneRate}`,
      StoneRate: `${stone.StoneRateKarate}`, // we have dont have stone rate , we have rate in carate and rate in pieces, for we kept stoneratepercarat
      StonePieces: `${stone.StonePieces}`,
      StoneAmount: `${stone.StoneAmount || "0"}`,
      Description: `${stone.Description || ""}`,
    }));
    const diamondDetails = product.Diamonds.map((diamond) => ({
      // DiamondName: `${diamond.DiamondName}`,  // we have removed diamond name from the fields
      DiamondWeight: `${diamond.DiamondWeight || "0"}`,
      DiamondRate: `${diamond.DiamondRate || "0"}`,
      DiamondPieces: `${diamond.DiamondPieces}`,
      DiamondAmount: `${diamond.DiamondAmount || "0"}`,
      DiamondClarity: `${diamond.DiamondClarity}`,
      DiamondColour: `${diamond.DiamondColour}`,
      DiamondCut: `${diamond.DiamondCut}`,
      DiamondShape: `${diamond.DiamondShape}`,
      DiamondSize: `${diamond.DiamondSize}`,
      Certificate: `${diamond.DiamondCertificate}`,
      SettingType: `${diamond.DiamondSettingType}`,
      // DiamondPurchaseAmt: `${diamond.DiamondPurchaseAmt}`,
      DiamondPurchaseAmt: "", // we dont have diamond purchase amt
      Description: `${diamond.DiamondDescription}`,
    }));
    const Payments = data?.paymentTypes?.map((payment) => {
      return {
        // ...payment,
        // id:""+payment?.id,
        CustomerId: 0,
        PaymentModeType: payment?.mode,
        PaymentSource: "Purchase Bill",
        CreditDebit: "Debit",
        Amount:  `${payment.amount}`,
        TransactionType: `${payment.status}`,
        InvoiceNumber: ""+data?.invoiceNumber,
        PaymentVisibility: "Active",
        FinancialYear: ""+currentYear,
        Branch: "Home",
        FineGold: ""+payment.MetalFinePaid,
        FineSilver: ""+payment.MetalFinePaid,
        FineOtherMetal: "",
        GoldRate: ""+payment.MetalCashRatePerGram,
        SilverRate: ""+payment.MetalCashRatePerGram,
        OtherMetalRate: "",
        GoldAmount: "", // we dont have this 
        SilverAmount: "", // we dont have this
        OtherMetalAmount: "", 
        OldGoldGrosswt: ""+payment.MetalFinePaid, 
        OldSilverGrosswt: ""+payment.MetalFinePaid,
        OtherMetalGrossWt: "",
        GoldPurity: "",
        SilverPurity: "",
        OtherMetalPurity: "",
        VendorId: data?.VendorName?.value,
        InvoiceId: 0,
        InwardNo: vendorlist?.find((item)=>data?.VendorName?.value == item?.Id)?.InwardNo + 1,
        OrderId: 0,
        CustomerName: "",
        VendorName: data?.VendorName?.label,
        RDPurchaseId: rcvdId,
        Status: "Purchased",
        Description: payment?.description,
        ClientCode: additionalInfo?.clientCode,
        CompanyId: additionalInfo?.CompanyId,
        CounterId: additionalInfo?.CounterId,
        BranchId: additionalInfo?.BranchId,
        EmployeId: additionalInfo?.employeeCode,
      };
    });

    const totalStoneWeight = product.StoneWt;
    const totalStoneAmount = product.StoneAmount;
    const diamondPieces = product?.Diamonds?.reduce(
      (acc, diamond) => acc + parseFloat(diamond.DiamondPieces || 0),
      0
    );

    return {
      StockKeepingUnit:product.StockKeepingUnit?.value && product.StockKeepingUnit?.value !=="undefined" ? `${product.StockKeepingUnit?.value}` : "",
      StockKeepingUnitName:product?.StockKeepingUnit?.label && product?.StockKeepingUnit?.label !=="undefined"  ? `${product.StockKeepingUnit?.label}` : "",
      ItemCode: product?.ItemCode || "", // what is item code
      MakingFixedAmt: `${product.MakingFixedAmt || 0}`,
      MakingPercentage: `${product.MakingPercentage || 0}`, // we dont have making percentage
      MakingPerGram: `${product.MakingPerGram || 0}`,
      MakingFixedWastage: `${product.MakingFixedWastage || 0}`,
      MetalRate: `${product.MetalRate || 0}`,
      FinePercent: `${product.FinePercent || 0}`,
      WastageWt: `${product.WastageWt || 0}`,
      WastagePercent: `${product.WastagePercent || 0}`,
      Quantity: `${product.Qty}`,
      CategoryId: product?.CategoryId?.value ? parseInt(product?.CategoryId?.value) : 0,
      ProductId: product?.ProductId?.value ? parseInt(product?.ProductId?.value) : 0,
      PurchaseEntryNo: "",
      // FineGoldWt: product.ConvertAmount ? "0" : `${product.FineGold}`,
      FineGoldWt: "0", // we dont have
      // FineSilverWt: product.ConvertAmount ? "0" : `${product.FineSilver}`,
      FineSilverWt: "0", // we dont have
      // FineOtherMetalWt: `${product.FineOtherMetalWt}`,
      FineOtherMetalWt: "0", // we dont have
      TotalWeight:product?.TotalWt,
      PackingWeight:product?.PackingWeight || 0,
      TotalItemAmt: `${parseFloat(product?.TotalItemAmount || 0).toFixed(2)}`,
      FineWt: `${parseFloat(product?.FineWt || 0).toFixed(3)}`,
      // FinePure: product.FinePure,
      FinePure: false, // we dont have
      // ConvertAmount: product.ConvertAmount,
      ConvertAmount: false, // we dont have
      AddToUnlabelled: `${product.unlabeled}`,
      FineWastageWt: `${parseFloat(product?.FineWastageWt || 0).toFixed(3)}`,
      RDPurchaseId: parseInt(rcvdId),
      CategoryName: product?.CategoryId?.label,
      ProductName: product?.ProductId?.label,
      GrossWt: `${product?.GrossWt}`,
      NetWt: `${product?.NetWt}`,
      StoneWt: `${product?.StoneWt || product?.StoneWeight}`,
      Stones: stoneDetails,
      Diamonds: diamondDetails,
      Payments:Payments,
      StoneWeight: `${totalStoneWeight || 0}`,
      StonePieces: `${product?.StonePieces || 0}`,
      StoneAmount: `${totalStoneAmount || 0}`,
      MetalId: parseInt(product?.CategoryId?.value),
      HallmarkAmt: `${product?.Hallmark || 0}`,
      TagWeight: `${product?.TagWt || 0}`,
      FindingWeight: `${product?.FindingWt || 0}`,
      LanyardWeight: `${product?.LanyardWt || 0}`,
      UnlabelledGoldWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("gold")
          ? `${product?.GrossWt}`
          : "0",
        
      UnlabelledOtherMetalWeight:
        !product.unlabeled &&
        !(
          product?.CategoryId?.label?.toLowerCase()?.includes("gold") &&
          !product?.CategoryId?.label?.toLowerCase()?.includes("silver")
        )
          ? `${product?.GrossWt}`
          : "0", // need to understand this properly have little confusion
      UnlabelledSilverWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("silver")
          ? `${product?.GrossWt}`
          : "0",
      MRP: `0`,
      DesignId:product?.DesignId?.value ? parseInt(product?.DesignId?.value) : 0,
      DesignName:product?.DesignId?.label,
      PurityId:product?.PurityId?.value ? parseInt(product?.PurityId?.value ) : 0,
      PurityName:product?.PurityId?.label,
      VendorName:data?.VendorName?.label,
      VendorId: `${data?.VendorName?.value}`, // Ensure selectedCustomer is defined
      SKUId: product?.SKUId ? product.SKUId : 0,
      ClipQuantity: `${product?.ClipQty}`,
      ClipWeight: `${product?.ClipWt}`,
      Testing: `${product?.Testing}`,
      ClientCode: additionalInfo?.clientCode,
      AssignedDiamondWeight: "0",
      AssignedGoldWeight: "0",
      AssignedOtherMetalWeight: "0",
      AssignedSilverWeight: "0",
      AvailableGrossWeight: !product?.unlabeled ? `${product?.GrossWt}` : "0",
      AvailableNetWeight: !product?.unlabeled ? `${product?.NetWt}` : "0",
      AvailableStoneWeight: !product?.unlabeled ? `${product?.StoneWt}` : "0",
      TotalDiamondWeight: `${parseFloat(product?.DiamondWeight || 0).toFixed(3)}`,
      // TotalDiamondQty: `${product.TotalDiamondQty}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondQty: `${diamondPieces || product?.DiamondPieces || 0}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondAmount: `${product.DiamondAmount}`,

      ///lose diamond and loose stone 

     


      DiamondShapeId:`${product?.DiamondShape?.value}`,
      DiamondShapeName:`${product?.DiamondShape?.label}`,
      DiamondColourId:`${product?.DiamondColour?.value}`,
      DiamondColourName:`${product?.DiamondColour?.label}`,
      DiamondClarityId:`${product?.DiamondClarity?.value}`,
      DiamondClarityName:`${product?.DiamondClarity?.label}`,
      DiamondSleeve:`${product?.DiamondSleve}`,
      DiamondSize:`${product?.DiamondSize}`,
      DiamondRate:`${product?.DiamondRate}`,
      DiamondCutId:`${product?.DiamondCut?.value}`,
      DiamondCutName:`${product?.DiamondCut?.label}`,
      DiamondSettingTypeId:`${product?.DiamondSettingType?.value}`,
      DiamondSettingTypeName:`${product?.DiamondSettingType?.label}`,
      DiamondCertificate:`${product?.DiamondCertificate}`,
      DiamondPacket:`${product?.DiamondPacket}`,
      DiamondBox:`${product.DiamondBox}`,
      DiamondDescription:`${product?.DiamondDescription}`,
      

      StoneName:`${product?.StoneName}`,
      StoneShapeId:`${product?.StoneShape?.value}`,  
      StoneShapeName:`${product?.StoneShape?.label}`,  
      StoneColourId:`${product?.StoneColour?.value}`,  
      StoneColourName:`${product?.StoneColour?.label}`,  
      StoneSize:`${product?.StoneSize}`,
      StoneRateCt:`${product?.StoneRateCt}`,
      StoneRatePc:`${product?.StoneRatePc}`,
      StoneSettingTypeId:`${product?.StoneSettingType?.value}`,
      StoneSettingTypeName:`${product?.StoneSettingType?.label}`,
      StoneCertificate:`${product?.StoneCertificate}`,
      StonePacket:`${product?.StonePacket}`,
      Box:`${product.Box}`,
      StoneDescription:`${product?.StoneDescription}`,
    

      
    };
  });
  return jsonData;
}

export function purchaseEntryEditJSon({rcvdId, data, additionalInfo ,vendorlist}){
  const currentYear = new Date().getFullYear(); 
  const jsonData = data?.skus?.map((product)=>{
    const stoneDetails = product.Stones.map((stone) => ({
      ...stone,
      StoneName: `${stone.StoneName}`,
      StoneWeight: `${stone.StoneWeight}`,
      // StoneRate: `${stone.StoneRate}`,
      StoneRate: `${stone.StoneRateKarate}`, // we have dont have stone rate , we have rate in carate and rate in pieces, for we kept stoneratepercarat
      StonePieces: `${stone.StonePieces}`,
      StoneAmount: `${stone.StoneAmount || "0"}`,
      Description: `${stone.Description || ""}`,
    }));
    const diamondDetails = product.Diamonds.map((diamond) => ({
      ...diamond,
      // DiamondName: `${diamond.DiamondName}`,  // we have removed diamond name from the fields
      DiamondWeight: `${diamond.DiamondWeight}`,
      DiamondRate: `${diamond.DiamondRate}`,
      DiamondPieces: `${diamond.DiamondPieces}`,
      DiamondAmount: `${diamond.DiamondAmount || "0"}`,
      DiamondClarity: `${diamond.DiamondClarity}`,
      DiamondColour: `${diamond.DiamondColour}`,
      DiamondCut: `${diamond.DiamondCut}`,
      DiamondShape: `${diamond.DiamondShape}`,
      DiamondSize: `${diamond.DiamondSize}`,
      Certificate: `${diamond.DiamondCertificate}`,
      SettingType: `${diamond.DiamondSettingType}`,
      // DiamondPurchaseAmt: `${diamond.DiamondPurchaseAmt}`,
      DiamondPurchaseAmt: "", // we dont have diamond purchase amt
      Description: `${diamond.DiamondDescription}`,
    }));
    const Payments = data?.paymentTypes?.map((payment) => {
      return {
        // ...payment,
        // id:""+payment?.id,
        ...payment,
        CustomerId: 0,
        PaymentModeType: payment?.mode,
        PaymentSource: "Purchase Bill",
        CreditDebit: "Debit",
        Amount:  `${payment.amount}`,
        TransactionType: `${payment.status}`,
        InvoiceNumber: ""+data?.invoiceNumber,
        PaymentVisibility: "Active",
        FinancialYear: ""+currentYear,
        Branch: "Home",
        FineGold: ""+payment.MetalFinePaid,
        FineSilver: ""+payment.MetalFinePaid,
        FineOtherMetal: "",
        GoldRate: ""+payment.MetalCashRatePerGram,
        SilverRate: ""+payment.MetalCashRatePerGram,
        OtherMetalRate: "",
        GoldAmount: "", // we dont have this 
        SilverAmount: "", // we dont have this
        OtherMetalAmount: "", 
        OldGoldGrosswt: ""+payment.MetalFinePaid, 
        OldSilverGrosswt: ""+payment.MetalFinePaid,
        OtherMetalGrossWt: "",
        GoldPurity: "",
        SilverPurity: "",
        OtherMetalPurity: "",
        VendorId: data?.VendorName?.value,
        InvoiceId: 0,
        InwardNo: vendorlist?.find((item)=>data?.VendorName?.value == item?.Id)?.InwardNo + 1,
        OrderId: 0,
        CustomerName: "",
        VendorName: data?.VendorName?.label,
        RDPurchaseId: rcvdId,
        Status: "Purchased",
        Description: payment?.description,
        ClientCode: additionalInfo?.clientCode,
        CompanyId: additionalInfo?.CompanyId,
        CounterId: additionalInfo?.CounterId,
        BranchId: additionalInfo?.BranchId,
        EmployeId: additionalInfo?.employeeCode,
      };
    });
    const totalStoneWeight = product.StoneWt;
    const totalStoneAmount = product.StoneAmount;
    const diamondPieces = product.Diamonds?.reduce(
      (acc, diamond) => acc + parseFloat(diamond.DiamondPieces || 0),
      0
    );

    return {
      ...product,
      StockKeepingUnit:product.StockKeepingUnit?.value && product.StockKeepingUnit?.value !=="undefined" ? `${product.StockKeepingUnit?.value}` : "",
      StockKeepingUnitName:product?.StockKeepingUnit?.label && product.StockKeepingUnit?.label !=="undefined" ? `${product.StockKeepingUnit?.label}` : "",
      ItemCode: product?.ItemCode || "", // what is item code
      MakingFixedAmt: `${product.MakingFixedAmt || 0}`,
      MakingPercentage: `${product.MakingPercentage || 0}`, // we dont have making percentage
      MakingPerGram: `${product.MakingPerGram || 0}`,
      MakingFixedWastage: `${product.MakingFixedWastage || 0}`,
      MetalRate: `${product.MetalRate || 0}`,
      FinePercent: `${product.FinePercent || 0}`,
      WastageWt: `${product.WastageWt || 0}`,
      WastagePercent: `${product.WastagePercent || 0}`,
      Quantity: `${product.Qty}`,
      CategoryId: product?.CategoryId?.value ? parseInt(product?.CategoryId?.value) : 0,
      ProductId: product?.ProductId?.value ? parseInt(product?.ProductId?.value) : 0,
      PurchaseEntryNo: "",
      // FineGoldWt: product.ConvertAmount ? "0" : `${product.FineGold}`,
      FineGoldWt: "0", // we dont have
      // FineSilverWt: product.ConvertAmount ? "0" : `${product.FineSilver}`,
      FineSilverWt: "0", // we dont have
      // FineOtherMetalWt: `${product.FineOtherMetalWt}`,
      FineOtherMetalWt: "0", // we dont have
      TotalWeight:product?.TotalWt,
      PackingWeight:product?.PackingWeight || 0,
      TotalItemAmt: `${parseFloat(product?.TotalItemAmount || 0).toFixed(2)}`,
      FineWt: `${parseFloat(product?.FineWt || 0).toFixed(3)}`,
      // FinePure: product.FinePure,
      FinePure: false, // we dont have
      // ConvertAmount: product.ConvertAmount,
      ConvertAmount: false, // we dont have
      AddToUnlabelled: `${product.unlabeled}`,
      FineWastageWt: `${parseFloat(product?.FineWastageWt || 0).toFixed(3)}`,
      RDPurchaseId: parseInt(rcvdId),
      CategoryName: product?.CategoryId?.label,
      ProductName: product?.ProductId?.label,
      GrossWt: `${product?.GrossWt}`,
      NetWt: `${product?.NetWt}`,
      StoneWt: `${product?.StoneWt}`,
      Stones: stoneDetails,
      Diamonds: diamondDetails,
      Payments:Payments,
      StoneWeight: `${totalStoneWeight || 0}`,
      StonePieces: `${product?.StonePieces || 0}`,
      StoneAmount: `${totalStoneAmount || 0}`,
      MetalId: parseInt(product?.CategoryId?.value),
      HallmarkAmt: `${product?.Hallmark || 0}`,
      TagWeight: `${product?.TagWt || 0}`,
      FindingWeight: `${product?.FindingWt || 0}`,
      LanyardWeight: `${product?.LanyardWt || 0}`,
      UnlabelledGoldWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("gold")
          ? `${product?.GrossWt}`
          : "0",
      UnlabelledOtherMetalWeight:
        !product.unlabeled &&
        !(
          product?.CategoryId?.label?.toLowerCase()?.includes("gold") &&
          !product?.CategoryId?.label?.toLowerCase()?.includes("silver")
        )
          ? `${product?.GrossWt}`
          : "0", // need to understand this properly have little confusion
      UnlabelledSilverWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("silver")
          ? `${product?.GrossWt}`
          : "0",
      MRP: `0`,
      DesignId:product?.DesignId?.value ? parseInt(product?.DesignId?.value) : 0,
      DesignName:product?.DesignId?.label,
      PurityId:product?.PurityId?.value ? parseInt(product?.PurityId?.value ) : 0,
      PurityName:product?.PurityId?.label,
      VendorName:data?.VendorName?.label,
      VendorId: `${data?.VendorName?.value}`, // Ensure selectedCustomer is defined
      SKUId: product?.SKUId ? product.SKUId : 0,
      ClipQuantity: `${product?.ClipQty}`,
      ClipWeight: `${product?.ClipWt}`,
      Testing: `${product?.Testing}`,
      ClientCode: additionalInfo?.clientCode,
      AssignedDiamondWeight: "0",
      AssignedGoldWeight: "0",
      AssignedOtherMetalWeight: "0",
      AssignedSilverWeight: "0",
      AvailableGrossWeight: !product?.unlabeled ? `${product?.GrossWt}` : "0",
      AvailableNetWeight: !product?.unlabeled ? `${product?.NetWt}` : "0",
      AvailableStoneWeight: !product?.unlabeled ? `${product?.StoneWt}` : "0",
      TotalDiamondWeight: `${parseFloat(product?.DiamondWeight || 0).toFixed(3)}`,
      // TotalDiamondQty: `${product.TotalDiamondQty}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondQty: `${diamondPieces}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondAmount: `${product.DiamondAmount}`,


        ///lose diamond and loose stone 

     
  
  
        DiamondShapeId:`${product?.DiamondShape?.value}`,
        DiamondShapeName:`${product?.DiamondShape?.label}`,
        DiamondColourId:`${product?.DiamondColour?.value}`,
        DiamondColourName:`${product?.DiamondColour?.label}`,
        DiamondClarityId:`${product?.DiamondClarity?.value}`,
        DiamondClarityName:`${product?.DiamondClarity?.label}`,
        DiamondSleeve:`${product?.DiamondSleve}`,
        DiamondSize:`${product?.DiamondSize}`,
        DiamondRate:`${product?.DiamondRate}`,
        DiamondCutId:`${product?.DiamondCut?.value}`,
        DiamondCutName:`${product?.DiamondCut?.label}`,
        DiamondSettingTypeId:`${product?.DiamondSettingType?.value}`,
        DiamondSettingTypeName:`${product?.DiamondSettingType?.label}`,
        DiamondCertificate:`${product?.DiamondCertificate}`,
        DiamondPacket:`${product?.DiamondPacket}`,
        DiamondBox:`${product.DiamondBox}`,
        DiamondDescription:`${product?.DiamondDescription}`,
        
  
        StoneName:`${product?.StoneName}`,
        StoneShapeId:`${product?.StoneShape?.value}`,  
        StoneShapeName:`${product?.StoneShape?.label}`,  
        StoneColourId:`${product?.StoneColour?.value}`,  
        StoneColourName:`${product?.StoneColour?.label}`,  
        StoneSize:`${product?.StoneSize}`,
        StoneRateCt:`${product?.StoneRateCt}`,
        StoneRatePc:`${product?.StoneRatePc}`,
        StoneSettingTypeId:`${product?.StoneSettingType?.value}`,
        StoneSettingTypeName:`${product?.StoneSettingType?.label}`,
        StoneCertificate:`${product?.StoneCertificate}`,
        StonePacket:`${product?.StonePacket}`,
        Box:`${product.Box}`,
        StoneDescription:`${product?.StoneDescription}`,
    };
   })
   
   return jsonData
}

export const looseStoneId = 12;
export const looseDiamondId = 8;

// export function

export const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px", // Decreases the height of the input
    height: "30px", // Ensures the height is consistent
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "14px", // Adjusts the font size of the selected value
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

export function getPurchaseDataToGenerateId() {
  const obj = {};
}


export const convertIntoFormData = (data,purchaseItems) => {



  return {
    ...data,  
    StockKeepingUnit: "",
    LotNumber: data?.LotNumber,
    ItemCode: "",
    MakingFixedAmt: 0,
    MakingPerGram: 0,
    MakingFixedWastage: 0,
    MakingPercentage: 0,
    MetalRate: 0,
    FinePercent: 0,
    WastagePercent: 0,
    Quantity: 1,
    PurityId: 0,
    CategoryId: 0,
    ProductId: 0,
    DesignId: 0,
    FineGoldWt: 0,
    FineSilverWt: 0,
    TotalFineGold: "-9.2",
    FineOtherMetalWt: 0,
    TotalStoneAmt: 0,
    TotalItemAmt: 0,
    FineWt: 0,
    WastageWt: 0,
    FineWastageWt: 0,
    RDPurchaseId: 0,
    CategoryName: "",
    ProductName: "",
    DesignName: "",
    GrossWt: 0,
    NetWt: 0,
    StoneWt: 0,
    Status: "Active",
    CounterId: 0,
    BranchId: 0,
    CompanyId: 0,
    FinePure: false,
    ClientCode: 0,
    AddToUnlabelled: false,
    MetalId: 0,
    MetalName: "",
    StoneName: "",
    StoneWeight: 0,
    StonePieces: 0,
    StoneRate: 0,
    StoneAmount: 0,
    HallmarkAmt: 0,
    TagWeight: 0,
    FindingWeight: 0,
    LanyardWeight: 0,
    Testing: "0",
    Stones: [],
    Diamonds: [],
    ConvertAmount: true,
    MRP: "0",
    ClipWeight: "0",
    ClipQuantity: "0",
    DiamondName: "",
    DiamondWeight: 0,
    DiamondRate: 0,
    DiamondPieces: 0,
    DiamondAmount: 0,
    DiamondSize: "0",
    DiamondPurchaseRate: "0",
    DiamondSellRate: "0",
    DiamondClarity: "",
    DiamondColour: "",
    DiamondShape: "",
    DiamondCut: "",
    DiamondSettingType: "",
    DiamondCertificate: "",
    DiamondPurchaseAmount: "0",
    DiamondSellAmount: "0",
    DiamondDescription: "",
    status: "",
    skus: purchaseItems?.map((item) => {
      return {
        ...item,
        
        unlabeled:item?.AddToUnlabelled == "true" ? true : item?.AddToUnlabelled == "false" ? false :false,
        ClipQty:""+item?.ClipQuantity,
        ClipWt:""+item?.ClipWeight,
        FindingWt:""+item?.FindingWeight,
        PackingWeight:""+item?.PackingWeight,
        TotalWt:""+item?.TotalWeight,
        GrossWt:""+(item?.GrossWt || 0),
        Hallmark:""+(item?.HallmarkAmt || 0),
        LanyardWt:""+(item?.LanyardWeight || 0),
        LotNumber:item?.LotNumber,
        Qty:""+(item?.Quantity || 0),
        StoneRateKarate:""+(item?.StoneRate || 0),
        TagWt:""+(item?.TagWeight || 0),
        DiamondAmount:""+(item?.TotalDiamondAmount || 0),
        diamondPieces:""+(item?.TotalDiamondQty || 0),
        DiamondWeight:""+(item?.TotalDiamondWeight || 0),
        TotalItemAmount:""+(item?.TotalItemAmt || 0),
        
        StockKeepingUnit:{
          value:item?.StockKeepingUnit !== "undefined" && item?.StockKeepingUnit ? ""+item?.StockKeepingUnit :"",
          label:item?.StockKeepingUnitName !== "undefined" && item?.StockKeepingUnitName ? ""+item?.StockKeepingUnitName:""
        },
        Diamonds: item?.Diamonds?.length
          ? item.Diamonds?.map((diamond) => {
              return {
                ...diamond,
                DiamondCertificate:diamond?.Certificate,
                DiamondDescription:diamond?.Description,
                DiamondAmount:diamond?.DiamondAmount,
                DiamondSettingType:diamond?.SettingType
              };
            })
          : [],
        Stones: item?.Stones?.length
          ? item.Stones?.map((stone) => {
              return {
                ...stone,
                StoneRateKarate:stone?.StoneRate,
              };
            })
          : [],

        CategoryId: {
          value: ""+item?.CategoryId,
          label: item?.CategoryName,
        },
        ProductId: {
          value: ""+item?.ProductId,
          label: item?.ProductName,
        },
        DesignId: {
          value: ""+item?.DesignId,
          label: item?.DesignName,
        },
        PurityId: {
          value: ""+item?.PurityId,
          label: item?.PurityName,
        },

        // loose diamond and loose stone
        StoneSettingType:{
          value: ""+item?.StoneSettingTypeId,
          label: item?.StoneSettingTypeName,
        },
        DiamondSettingType:{
          value: ""+item?.DiamondSettingTypeId,
          label: item?.DiamondSettingTypeName,
        },
        StoneCertificate:item?.StoneCertificate,
        DiamondCertificate:item?.DiamondCertificate,
        StonePacket:item?.StonePacket,
        DiamondPacket:item?.DiamondPacket,
        DiamondBox:item?.DiamondBox,
        Box:item?.Box,
        StoneDescription:item?.StoneDescription,
        DiamondDescription:item?.DiamondDescription,

        DiamondShape:{
          value: ""+item?.DiamondShapeId,
          label: item?.DiamondShapeName,
        },
        DiamondColour:{
          value: ""+item?.DiamondColourId,
          label: item?.DiamondColourName,
        },
        DiamondClarity:{
          value: ""+item?.DiamondClarityId,
          label: item?.DiamondClarityName,
        },
        DiamondSleeve:""+item?.DiamondSleeve,
        DiamondSize:""+item?.DiamondSize,
        DiamondRate:""+item?.DiamondRate,
        DiamondCut:{
          value: ""+item?.DiamondCutId,
          label: item?.DiamondCutName,
        },
        StoneName:item?.StoneName,
        StoneShape:{
          value: ""+item?.StoneShapeId,
          label: item?.StoneShapeName,
        },
        StoneColour:{
          value: ""+item?.StoneColourId,
          label: item?.StoneColourName,
        },
        StoneSize:""+item?.StoneSize,
        StoneRateCt:""+item?.StoneRateCt,
        StoneRatePc:""+item?.StoneRatePc

      };
    }),
    
    paymentTypes: data?.Payments?.length 
      ? data?.Payments?.map((payment) => {
          return {
            ...payment,
            mode:payment?.PaymentModeType,
            amount:payment?.Amount,
            status:payment?.TransactionType,
            invoiceNumber:payment?.InvoiceNumber,
            MetalFinePaid:payment?.FineGold || payment?.FineSilver,
            MetalCashRatePerGram:payment?.GoldRate || payment?.SilverRate,
            MetalFinePaid:payment?.FineGold || payment?.FineSilver,
            VendorName:{value:payment?.VendorId,label:payment?.VendorName},
            description:payment?.Description,            
          };
        })
      : [],

    balanceGold:data?.BalanceGold,
    taxableAmount: "",
    gst: "",
    paidAmount: "",
    balanceSilver: "",
    RODiscount: "",
    totalAmount: "",
    balanceAmount: "",
    invoiceDate: data?.PurchaseDate ,
    invoiceNumber: data?.InvoiceNo,
    TotalFineSilver: "0",
    advanceamount: "0",
    balanceamount: "0",
    TotalFineMetal: data?.TotalFineGold ||  data?.TotalFineSilver, // 
    TotalPaidMetal: "0.000", // not available
    TotalBalanceMetal: data?.BalanceGold || data?.BalanceSilver, //  not available
    TotalAdvanceAmount: "0.000", // not available
    TotalPaidAmount: "0.000", // not available
    TotalTaxableAmount: data?.TotalNetAmount || "0.000",
    gstCheckbox: data?.GSTApplied == "true" ? true : false,
    TotalGst: data?.TotalGSTAmount || "0.000",
    TotalRODiscount: data?.Discount || "0.000",
    TotalBillAmount: data?.TotalPurchaseAmount || "0.000",
    TotalBalanceAmount: data?.BalanceAmount || "0.000",
    VendorName: {
      value: data?.VendorId,
      label: data?.Payments[0]?.VendorName,
    },
  };
};



export function getTodaysDateFormat(){
  const today = new Date();
  const year = today.getFullYear();
  // Pad the month and day with a leading zero if they are less than 10
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


export function getInvoiceEntryFormData({
  data,
  customerList,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName
}){
    const paymentsString = data?.paymentTypes?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
    const urdPurchaseAmt = 0 // not available in our system
    const totalPaidAmount = data?.paymentTypes.reduce(
      (total, payment) =>
        total +
        (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
      0
    );
    const allProdctsNetAmount = data?.skus?.reduce((total,product)=>total + +(product?.FinalPrice || 0),0)
    const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0)
    const totalGrossWt = data?.skus?.reduce((total,product)=>total + +(product?.GrossWt || 0),0)
    const totalNetWt = data?.skus?.reduce((total,product)=>total + +(product?.NetWt || 0) , 0)
    const totalQuantity = data?.skus?.reduce(
      (a, b) => a + +(b?.Qty || b?.Pieces ||  0),
      0
    );  
    const totalStoneWt = data?.skus?.reduce(
      (a, b) =>
        a + +(b?.StoneWt || 0),
      0
    );

    const orderItemsList = data?.skus?.map((product) => {
      let item = {
        BillType: "sale",
        SKUId:product?.SKUId ? `${product?.SKUId}`:"", // need to add 
        SKU:product?.SKU ? `${product?.SKU}`:"", // need to add 
        CategoryName:product.CategoryName ? `${product.CategoryName}`:"",
        CategoryId: product.CategoryId ? `${product.CategoryId}` :"",// need to add 
        ProductId: product.ProductId ? `${product.ProductId}` :"",
        ProductName: product?.ProductName ? `${product?.ProductName}` :"",
        PurityId: product?.PurityId ? `${product?.PurityId}` :"" ,
        Purity: product?.PurityName ? `${product?.PurityName}` :"", 
        DesignId:product?.DesignId ? `${product?.DesignId}` :"", // need to add
        DesignName:product?.DesignName ? `${product?.DesignName}` :"", // need to add
        TotalWt:product?.TotalWeight ? `${product?.TotalWeight}` :"",
        PackingWeight:product?.PackingWeight ? `${product?.PackingWeight}` :"",
        GrossWt: product?.GrossWt ? `${product?.GrossWt}`:"",
        TotalStoneWeight: product?.TotalStoneWeight ? `${product?.TotalStoneWeight}` :"" ,
        DiamondWeight:product?.DiamondWeight ? `${product?.DiamondWeight}`:"",
        NetWt: product?.NetWt ? `${product?.NetWt}` :"", 
        MetalRate:product?.MetalRate ? `${product?.MetalRate}`:"", // little confusion is gold rate metal rate same ?
        Quantity: `${product?.Quantity ||  product?.Pieces || 0}`,
        FinePercentage:product?.FinePercent ? `${product?.FinePercent}` :"",
        MakingPercentage: product?.MakingPercentage ? `${product?.MakingPercentage}` :"",
        MakingPerGram:product?.MakingPerGram ? `${product?.MakingPerGram}` :"",
        MakingFixedAmt: product?.MakingFixedAmt,
        MakingFixedWastage: product?.MakingFixedWastage,
        TotalStonePieces:product?.TotalStonePieces, // need to add 
        StoneAmount: product?.StoneAmount || product?.TotalStoneAmount,
        TotalStoneAmount: product?.TotalStoneAmount, // we dont have this
        HallmarkAmount: product?.HallmarkAmount,
        MetalAmount:product?.MetalAmount,
        FineWt:product?.FineWt, // need to add
        WastageWt: product?.WastageWt, 
        FineWastageWt:product?.FineWastageWt, // need to add
        CuttingGrossWt:product?.CuttingGrossWt,
        CuttingNetWt:product?.CuttingNetWt,
        MRP: `${product?.MRP}`,
        TotalItemAmount:product?.TotalItemAmount,

        CustomerId: parseInt(data?.customerName?.value || 0),
       
    


        HSNCode: `${product?.HSNCode || ""}`,
        
        MakingCharg:product?.MakingCharg || "",
        ProductCode: "",
        ProductNo: "",
        NetAmount:product?.NetAmount,
        GSTAmount:product?.GSTAmount,
        totalGstAmount:product?.totalGstAmount,
        TotalAmount:product?.TotalAmount,
       
        finalPrice:product?.finalPrice,
        ConvertAmt:product?.ConvertAmt,
       
        MakingCharg: product?.Making ? `${product?.Making}` : "0",
       
        HUIDCode:product?.HUIDCode || "", // we don't have this 
        Size: product?.Size || "", // we don't have this
        
        OnlineStatus: "Billed",
        Price: `${(
          parseFloat(product?.FinalPrice || 0) + parseFloat(product?.TotalGST || 0)
        ).toFixed(3)}`,

        LabelledStockId: product?.sell ? product.Id : 0,  // Ensure LabelledStockId is present
        Stones: product?.Stones && product?.Stones?.length > 0 ? product.Stones : [],  // Ensure Stones array
        Diamonds: product?.Diamonds && product?.Diamonds?.length > 0 ? product.Diamonds : [],
        ItemCode: product?.ItemCode || "",


       
      };
    

      return item;
    });
    const currentYear = new Date().getFullYear();

     const paymentsList = data?.paymentTypes?.map((payment) => {
          return  {
            ClientCode: clientCode,
            PaymentSource: "Sale Bill",
            Description: payment?.description,
            PaymentModeType: `${payment?.mode}`,
            CreditDebit: "Credit",
            Amount: `${payment?.amount}`,
            TransactionType: `${payment.status}`,
            // TransactionType: "Receive",
            VendorId: 0,
            InvoiceNumber: "",
            CustomerId: parseInt(data?.customerName?.value || ""),
            BillType: "sale",
            PaymentVisibility: "Active",
            FinancialYear: `${currentYear}`,
            Branch: "Home",
            CompanyId: CompanyId ? CompanyId : 0,
            CounterId: CounterId ? CounterId : 0,
            BranchId: BranchId ? BranchId : 0,
            EmployeId: EmployeeId ? EmployeeId : 0,
            FineGold: ""+payment.MetalFinePaid,
            FineSilver: ""+payment.MetalFinePaid,
            GoldRate: ""+payment.MetalCashRatePerGram,
            SilverRate: ""+payment.MetalCashRatePerGram,
            OldGoldGrosswt: ""+payment.MetalFinePaid, 
            OldSilverGrosswt: ""+payment.MetalFinePaid,
            // SilverAmount: `${payment.goldAmount}`,
            // GoldAmount: `${payment.silverAmount}`,
           
            FineGold: "0",
    
            FineSilver: "0",
            FineOtherMetal: "0",
            GoldRate: "0",
            SilverRate: "0",
            OtherMetalRate: "0",
            GoldAmount: "0",
            SilverAmount: "0",
            OtherMetalAmount: "0",
            OldGoldGrosswt: "0",
            OldSilverGrosswt: "0",
            OtherMetalGrossWt: "0",
            GoldPurity: "",
            SilverPurity: "",
            OtherMetalPurity: "",
            PurchaseOrderId: 0,
            OrderId: 0,
            InvoiceId: 0,
            RDPurchaseId: 0,
            CustomerName: `${data?.customerName?.label}`,
            VendorName: "",
            InwardNo: "0",
            Status: "Sold",


          };
    
      
        });


    const formData = {
           ClientCode: clientCode,
           CustomerId: `${data?.customerName?.value}` || "",
           Billedby: `${data?.selectedCashierEmployee || `${employeeFirstName} ${employeeLastName}`}`,
           SaleType: "Sale",
           Soldby: `${data?.selectedSalesEmployee || employeeFirstName}`,
           PaymentMode: `${paymentsString}`,
           UrdPurchaseAmt: `${parseFloat(urdPurchaseAmt)?.toFixed(3)}`, // we dont have this
           GST: `${parseFloat(data?.TotalGst)?.toFixed(3)}`,
           ReceivedAmount: parseFloat(data?.TotalPaidAmount)?.toFixed(2),
           InvoiceStatus:  data?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
           Visibility: data?.gstCheckbox ? "Visible" : "Hidden",
           
           Offer: `${data?.TotalRODiscount || 0}`,
           TotalAmount: `${parseFloat(data?.TotalTaxableAmount).toFixed(3)}`,
           BillType: `${data?.gstCheckbox}`,
           InvoiceDate: `${data?.invoiceDate || getTodaysDateFormat()}`,
           InvoiceNo:data?.invoiceNumber,
           BalanceAmt: `${parseInt(grandTotal)}`,
           CreditAmount: "0",
           CreditGold: "0",
           CreditSilver: "0",
           GrossWt: `${totalGrossWt}`,
           NetWt: `${totalNetWt}`,
           StoneWt: `${(totalStoneWt).toFixed(3)}`,
           Qty: `${totalQuantity}`,
          
           TotalDiamondAmount: "0",
           TotalDiamondPieces: "0",
           TotalDiamondWeight: "0",
           TotalSaleGold: "0",
           TotalSaleSilver: "0",
           TotalSaleUrdGold: "0",
           TotalSaleUrdSilver: "0",
           TotalStoneAmount: "0",
           TotalStonePieces: "0",
           TotalStoneWeight: "0",
   
           BalanceGold: "0",
           BalanceSilver: "0",
           OrderType:"Tax Invoice", // not clear what to do
            // pendingApproval
            //  ? "Pending Approval"
            //  : !pendingApproval && !applyGstAmount
            //    ? "Estimate"
            //    : "Tax Invoice",
   
           InvoiceItem: orderItemsList,
           Payments: paymentsList,

           TotalNetAmount:parseFloat(data?.TotalTaxableAmount || 0).toFixed(3),
           TotalFineMetal:     parseFloat(data?.TotalFineMetal || 0).toFixed(3)
           , // 
           TotalBalanceMetal:    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
           , //  not available
           GSTApplied:data?.gstCheckbox ? "true" :"false",
           TotalGSTAmount:parseFloat(data?.TotalGst || 0).toFixed(3),
           Discount:parseFloat(data?.TotalRODiscount || 0).toFixed(3),
           TotalPurchaseAmount: parseFloat(data?.TotalBillAmount || 0).toFixed(3),
           BalanceAmount:parseFloat(data?.TotalBalanceAmount || 0).toFixed(3)
         };

   return formData
}
export function getInvoiceEditEntryFormData({
  data,
  customerList,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName
}){
    const paymentsString = data?.paymentTypes?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
    const urdPurchaseAmt = 0 // not available in our system
    const totalPaidAmount = data?.paymentTypes.reduce(
      (total, payment) =>
        total +
        (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
      0
    );
    const allProdctsNetAmount = data?.skus?.reduce((total,product)=>total + +(product?.FinalPrice || 0),0)
    const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0)
    const totalGrossWt = data?.skus?.reduce((total,product)=>total + +(product?.GrossWt || 0),0)
    const totalNetWt = data?.skus?.reduce((total,product)=>total + +(product?.NetWt || 0) , 0)
    const totalQuantity = data?.skus?.reduce(
      (a, b) => a + +(b?.Qty || b?.Pieces ||  0),
      0
    );  
    const totalStoneWt = data?.skus?.reduce(
      (a, b) =>
        a + +(b?.StoneWt || 0),
      0
    );

    const orderItemsList = data?.skus?.map((product) => {
      let item = {
        ...product,
        BillType: "sale",
        SKUId:product?.SKUId ? `${product?.SKUId}`:"", // need to add 
        SKU:product?.SKU ? `${product?.SKU}`:"", // need to add 
        CategoryName:product.CategoryName ? `${product.CategoryName}`:"",
        CategoryId: product.CategoryId ? `${product.CategoryId}` :"",// need to add 
        ProductId: product.ProductId ? `${product.ProductId}` :"",
        ProductName: product?.ProductName ? `${product?.ProductName}` :"",
        PurityId: product?.PurityId ? `${product?.PurityId}` :"" ,
        Purity: product?.PurityName ? `${product?.PurityName}` :"", 
        DesignId:product?.DesignId ? `${product?.DesignId}` :"", // need to add
        DesignName:product?.DesignName ? `${product?.DesignName}` :"", // need to add
        TotalWt:product?.TotalWeight ? `${product?.TotalWeight}` :"",
        PackingWeight:product?.PackingWeight ? `${product?.PackingWeight}` :"",
        GrossWt: product?.GrossWt ? `${product?.GrossWt}`:"",
        TotalStoneWeight: product?.TotalStoneWeight ? `${product?.TotalStoneWeight}` :"" ,
        DiamondWeight:product?.DiamondWeight ? `${product?.DiamondWeight}`:"",
        NetWt: product?.NetWt ? `${product?.NetWt}` :"", 
        MetalRate:product?.MetalRate ? `${product?.MetalRate}`:"", // little confusion is gold rate metal rate same ?
        Quantity: `${product?.Quantity ||  product?.Pieces || 0}`,
        FinePercentage:product?.FinePercent ? `${product?.FinePercent}` :"",
        MakingPercentage: product?.MakingPercentage ? `${product?.MakingPercentage}` :"",
        MakingPerGram:product?.MakingPerGram ? `${product?.MakingPerGram}` :"",
        MakingFixedAmt: product?.MakingFixedAmt,
        MakingFixedWastage: product?.MakingFixedWastage,
        TotalStonePieces:product?.TotalStonePieces, // need to add 
        StoneAmount: product?.StoneAmount || product?.TotalStoneAmount,
        TotalStoneAmount: product?.TotalStoneAmount, // we dont have this
        HallmarkAmount: product?.HallmarkAmount,
        MetalAmount:product?.MetalAmount,
        FineWt:product?.FineWt, // need to add
        WastageWt: product?.WastageWt, 
        FineWastageWt:product?.FineWastageWt, // need to add
        CuttingGrossWt:product?.CuttingGrossWt,
        CuttingNetWt:product?.CuttingNetWt,
        MRP: `${product?.MRP}`,
        TotalItemAmount:product?.TotalItemAmount,

        CustomerId: parseInt(data?.customerName?.value || 0),
       
    


        HSNCode: `${product?.HSNCode || ""}`,
        
        MakingCharg:product?.MakingCharg || "",
        ProductCode: "",
        ProductNo: "",
        NetAmount:product?.NetAmount,
        GSTAmount:product?.GSTAmount,
        totalGstAmount:product?.totalGstAmount,
        TotalAmount:product?.TotalAmount,
       
        finalPrice:product?.finalPrice,
        ConvertAmt:product?.ConvertAmt,
       
        MakingCharg: product?.Making ? `${product?.Making}` : "0",
       
        HUIDCode:product?.HUIDCode || "", // we don't have this 
        Size: product?.Size || "", // we don't have this
        
        OnlineStatus: "Billed",
        Price: `${(
          parseFloat(product?.FinalPrice || 0) + parseFloat(product?.TotalGST || 0)
        ).toFixed(3)}`,

        LabelledStockId: product?.sell ? product.Id : 0,  // Ensure LabelledStockId is present
        Stones: product?.Stones && product?.Stones?.length > 0 ? product.Stones : [],  // Ensure Stones array
        Diamonds: product?.Diamonds && product?.Diamonds?.length > 0 ? product.Diamonds : [],
        ItemCode: product?.ItemCode || "",


       
      };
    

      return item;
    });
    const currentYear = new Date().getFullYear();

     const paymentsList = data?.paymentTypes?.map((payment) => {
          return  {
            ...payment,
            ClientCode: clientCode,
            PaymentSource: "Sale Bill",
            Description: payment?.description,
            PaymentModeType: `${payment?.mode}`,
            CreditDebit: "Credit",
            Amount: `${payment?.amount}`,
            // TransactionType: `${payment.paymentType}`,
            TransactionType: "Receive",
            VendorId: 0,
            InvoiceNumber: "",
            CustomerId: parseInt(data?.customerName?.value || ""),
            BillType: "sale",
            PaymentVisibility: "Active",
            FinancialYear: `${currentYear}`,
            Branch: "Home",
            CompanyId: CompanyId ? CompanyId : 0,
            CounterId: CounterId ? CounterId : 0,
            BranchId: BranchId ? BranchId : 0,
            EmployeId: EmployeeId ? EmployeeId : 0,
            FineGold: ""+payment.MetalFinePaid,
            FineSilver: ""+payment.MetalFinePaid,
            GoldRate: ""+payment.MetalCashRatePerGram,
            SilverRate: ""+payment.MetalCashRatePerGram,
            OldGoldGrosswt: ""+payment.MetalFinePaid, 
            OldSilverGrosswt: ""+payment.MetalFinePaid,
            // SilverAmount: `${payment.goldAmount}`,
            // GoldAmount: `${payment.silverAmount}`,
           
            FineGold: "0",
    
            FineSilver: "0",
            FineOtherMetal: "0",
            GoldRate: "0",
            SilverRate: "0",
            OtherMetalRate: "0",
            GoldAmount: "0",
            SilverAmount: "0",
            OtherMetalAmount: "0",
            OldGoldGrosswt: "0",
            OldSilverGrosswt: "0",
            OtherMetalGrossWt: "0",
            GoldPurity: "",
            SilverPurity: "",
            OtherMetalPurity: "",
            PurchaseOrderId: 0,
            OrderId: 0,
            InvoiceId: 0,
            RDPurchaseId: 0,
            CustomerName: `${data?.customerName?.label}`,
            VendorName: "",
            InwardNo: "0",
            Status: "Sold",


          };
    
      
        });


    const formData = {
           ...data,
           ClientCode: clientCode,
           CustomerId: `${data?.customerName?.value}` || "",
           Billedby: `${data?.selectedCashierEmployee || `${employeeFirstName} ${employeeLastName}`}`,
           SaleType: "Sale",
           Soldby: `${data?.selectedSalesEmployee || employeeFirstName}`,
           PaymentMode: `${paymentsString}`,
           UrdPurchaseAmt: `${parseFloat(urdPurchaseAmt)?.toFixed(3)}`, // we dont have this
           GST: `${parseFloat(data?.TotalGst)?.toFixed(3)}`,
           ReceivedAmount: parseFloat(data?.TotalPaidAmount)?.toFixed(2),
           InvoiceStatus:  data?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
           Visibility: data?.gstCheckbox ? "Visible" : "Hidden",
           
           Offer: `${data?.TotalRODiscount || 0}`,
           TotalAmount: `${parseFloat(data?.TotalTaxableAmount).toFixed(3)}`,
           BillType: `${data?.gstCheckbox}`,
           InvoiceDate: `${data?.invoiceDate || getTodaysDateFormat()}`,
           InvoiceNo:data?.invoiceNumber,

           BalanceAmt: `${parseInt(grandTotal)}`,
           CreditAmount: "0",
           CreditGold: "0",
           CreditSilver: "0",
           GrossWt: `${totalGrossWt}`,
           NetWt: `${totalNetWt}`,
           StoneWt: `${(totalStoneWt).toFixed(3)}`,
           Qty: `${totalQuantity}`,
          
           TotalDiamondAmount: "0",
           TotalDiamondPieces: "0",
           TotalDiamondWeight: "0",
           TotalSaleGold: "0",
           TotalSaleSilver: "0",
           TotalSaleUrdGold: "0",
           TotalSaleUrdSilver: "0",
           TotalStoneAmount: "0",
           TotalStonePieces: "0",
           TotalStoneWeight: "0",
   
           BalanceGold: "0",
           BalanceSilver: "0",
           OrderType:"Tax Invoice", // not clear what to do
            // pendingApproval
            //  ? "Pending Approval"
            //  : !pendingApproval && !applyGstAmount
            //    ? "Estimate"
            //    : "Tax Invoice",
   
           InvoiceItem: orderItemsList,
           Payments: paymentsList,

           TotalNetAmount:parseFloat(data?.TotalTaxableAmount || 0).toFixed(3),
           TotalFineMetal:     parseFloat(data?.TotalFineMetal || 0).toFixed(3)
           , // 
           TotalBalanceMetal:    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
           , //  not available
           GSTApplied:data?.gstCheckbox ? "true" :"false",
           TotalGSTAmount:parseFloat(data?.TotalGst || 0).toFixed(3),
           Discount:parseFloat(data?.TotalRODiscount || 0).toFixed(3),
           TotalPurchaseAmount: parseFloat(data?.TotalBillAmount || 0).toFixed(3),
           BalanceAmount:parseFloat(data?.TotalBalanceAmount || 0).toFixed(3)
         };

   return formData
}


export function convertInInvoiceWholeSaleFormat(data){
   console.log(data)
   return {
    ...data,
    SKUId:data?.StockKeepingUnit?.value,
    SKU:data?.StockKeepingUnit?.label,
    CategoryId:data?.CategoryId?.value,
    CategoryName:data?.CategoryId?.label,
    DesignId:data?.DesignId?.value,
    DesignName:data?.DesignId?.DesignName,
    ProductId:data?.ProductId?.value,
    ProductName:data?.ProductId?.label,
    PurityId:data?.PurityId?.value,
    PurityName:data?.PurityId?.label,
    TotalWeight:data?.TotalWt,
    PackingWeight:data?.PackingWeight,
    GrossWt:data?.GrossWt,
    TotalStoneWeight:data?.StoneWt,
    TotalDiamondWeight:data?.DiamondWeight,
    DiamondWeight:data?.DiamondWeight,
    NetWt:data?.NetWt,
    MetalRate:data?.GoldRate,
    Pieces:data?.Qty,
    Quantity:data?.Qty, // need to add in backend
    FinePercent:data?.FinePercent,
    MakingPercentage:data?.MakingPercent,
    MakingPerGram:data?.MakingPerGram,
    MakingFixedAmt:data?.MakingFixedAmt,
    MakingFixedWastage:data?.MakingFixedWastage,
    TotalStonePieces:data?.StonePieces,
    TotalStoneAmount:data?.StoneAmount || "0",
    HallmarkAmount:data?.Hallmark || "0",
    MetalAmount:data?.MetalAmount || "0", // need to add in backend
    CuttingGrossWt:data?.CuttingGrossWt, // need to add in backend
    CuttingNetWt:data?.CuttingNetWt, // need to add in backend
    MRP:data?.MRP,
   
   }
}


export function editInvoiceValueFormat(data,payments){
  console.log(data)
  console.log(payments)
  const paymentList = payments?.map((item)=>{
    return {
      ...item,
      description:item?.Description,
      mode:item?.PaymentModeType,
      amount:item?.Amount,
      status:item?.TransactionType,
      invoiceNumber:item?.InvoiceNumber,
      MetalFinePaid:item?.FineGold || item?.FineSilver,
      MetalCashRatePerGram:item?.GoldRate || item?.SilverRate,
      MetalFinePaid:item?.FineGold || item?.FineSilver,
      description:item?.Description,            

    }
  })
  console.log(data?.InvoiceItem)
  const skuItems = data?.InvoiceItem?.map((item)=>{
    
    return {
      ...item,
      SKU:item?.SKU,
      
      PurityName:item?.Purity,
      TotalWeight:item?.TotalWt,
      Quantity:+item?.Quantity,
      FinePercent:item?.FinePercentage,
    }

  })
return {
  ...data,
  invoiceNumber:data?.InvoiceNo,
  invoiceDate:data?.InvoiceDate,

  balanceGold:data?.TotalBalanceMetal,
  TotalFineMetal: data?.TotalFineMetal, // 
  TotalBalanceMetal: data?.TotalBalanceMetal, //  not available
  TotalTaxableAmount: data?.TotalNetAmount || "0.000",
  gstCheckbox: data?.GSTApplied == "true" ? true : false,
  TotalGst: data?.TotalGSTAmount || "0.000",
  TotalRODiscount: data?.Discount || "0.000",
  TotalBillAmount: data?.TotalPurchaseAmount || "0.000",
  TotalBalanceAmount: data?.BalanceAmount || "0.000",


  customerName:{value:data?.Customer?.Id,label:data.Customer?.FirstName},
  paymentTypes:paymentList,
  skus:skuItems
}
}


export function resetValues(setValue){
   setValue("StockKeepingUnit","")
   setValue("CategoryId","")
   setValue("ProductId","")
   setValue("DesignId","")
   setValue("PurityId","")
   setValue("TotalWt","")
   setValue("PackingWeight","")
   setValue("GrossWt","")
   setValue("StoneWt","")
   setValue("DiamondWeight","")
   setValue("NetWt","")
   setValue("GoldRate","")
   setValue("Qty","")
   setValue("FinePercent","")
   setValue("MakingPercent","")
   setValue("MakingPerGram","")
   setValue("MakingFixedAmt","")
   setValue("MakingFixedWastage","")
   setValue("StonePieces","")
   setValue("StoneAmount","")
   setValue("Hallmark","")
   setValue("MetalAmount","")
   setValue("TotalMakingAmount","")
   setValue("TotalItemAmount","")
   setValue("FineWt","")
   setValue("WastageWt","")
   setValue("FineWastageWt","")
   setValue("CuttingGrossWt","")
   setValue("CuttingNetWt","")
   setValue("MRP","")
   setValue("RatePerGram","")
   setValue("Amount","")
}


export function getCurrentFinancialYear() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // January is 0, February is 1, ..., December is 11
  
  // If the current month is before April (0, 1, 2), it's part of the previous financial year
  if (month < 3) {
    return `${year - 1}-${year}`;
  } else {
    return `${year}-${year + 1}`;
  }
}


export const VendorTounchSkuColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "StockKeepingUnit", label: "SKU", type: "read", priority: 2 },
  { key: "CategoryName", label: "Category", type: "read", priority: 3 },
  { key: "ProductName", label: "Product", type: "read", priority: 4 },
  { key: "PurityName", label: "Purity", type: "read", priority: 5 },
  { key: "Pieces", label: "Pieces", type: "read", priority: 6 },
  { key: "SketchNo", label: "Sketch Number", type: "read", priority: 7 },
  {
    key: "WeightCategories",
    label: "Weight Categories",
    type: "read",
    priority: 8,
  },
];
export const VendorTounchStonesColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "StoneName", label: "Stone Name", type: "read", priority: 2 },
  { key: "StoneRate", label: "Rate", type: "read", priority: 3 },
  
];